.userData_list {
  border-top: 1px solid;
  border-color: light-dark(var(--mantine-color-secondary-0), var(--mantine-color-primaryDark-7));
}

.redColorText {
  color: light-dark(var(--mantine-color-danger-6), var(--mantine-color-red-text));
}

.actionDeleteIcons:not(:disabled) {
  background-color: light-dark(var(--mantine-color-danger-1), var(--mantine-color-primaryDark-7));
}

.actionDeleteIcons:hover:not(:disabled) {
  background-color: light-dark(var(--mantine-color-danger-2), var(--mantine-color-primaryDark-6));
}

.buttonDeleteAccount {
  border-color: #dc362e;
}

.buttonDeleteAccount:not(:disabled) {
  background-color: light-dark(var(--mantine-color-danger-0), var(--mantine-color-primaryDark-7));
}

.buttonDeleteAccount:hover:not(:disabled) {
  background-color: light-dark(var(--mantine-color-danger-1), var(--mantine-color-primaryDark-6));
}
